import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { hymotsESocketHelper } from '../helpers';
import { base64ToArrayBuffer, blobToJSON } from '../helpers/quads.helper';
import { isJSON } from 'class-validator';
import { updateExperimentationStatus } from 'src/app/redux/actions/contents.actions';
import { socketActions } from '../redux/actions';
import { StatusEnum } from 'src/enums/experimentation.enum';

export const UseHymotseSocket = () => {
  const { hymotseConnected, hymotseStarted } = useSelector((state: reduxRootTypes.RootStateType) => state.socketState);

  const dispatch = useDispatch();

  const hymotseSocketListenerHandler = useCallback(() => {
    if (hymotseConnected) {
      hymotsESocketHelper.listenSocket(async (event: any) => {
        try {
          const { data } = event;
          const parsedData = JSON.parse(data);

          if (parsedData.zipliMi && parsedData.icerik) {
            console.time('zip');

            const arrayBuffer = base64ToArrayBuffer(parsedData.icerik);
            parsedData.icerik = await blobToJSON(new Blob([arrayBuffer]));

            console.timeEnd('zip');
          }

          if (isJSON(data)) {
            const genericMessage: any = parsedData;

            if (genericMessage.mesajTipi === 1 && genericMessage.mesajAltTipi === 2) {
            } else {
              switch (genericMessage.mesajTipi) {
                case 13:
                  if (genericMessage.icerik.deneyDurumu === 1) {
                    dispatch(updateExperimentationStatus(genericMessage.icerik.id, StatusEnum.DENEY_BASLADI));
                    dispatch(socketActions.hymotseStarted(true));
                  } else if (genericMessage.icerik.deneyDurumu === 5) {
                    dispatch(updateExperimentationStatus(genericMessage.icerik.id, StatusEnum.HESAPLAMA_BASLADI));
                  } else if (genericMessage.icerik.deneyDurumu === 7) {
                    dispatch(updateExperimentationStatus(genericMessage.icerik.id, StatusEnum.HESAPLAMA_BITTI));
                    dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.icerik.deneyDurumu === 11) {
                    dispatch(
                      updateExperimentationStatus(
                        genericMessage.icerik.id,
                        StatusEnum.HESAPLAMA_BASARILI_OYUN_SAYISI_YETERSIZ,
                      ),
                    );
                    dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.icerik.deneyDurumu === 6) {
                    dispatch(updateExperimentationStatus(genericMessage.icerik.id, StatusEnum.HESAPLAMA_BASLAMADI));
                    dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.icerik.deneyDurumu === 8) {
                    dispatch(
                      updateExperimentationStatus(
                        genericMessage.icerik.id,
                        StatusEnum.HESAPLAMA_ICIN_DENEY_DURUMU_BULUNMUYOR,
                      ),
                    );
                    dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.icerik.deneyDurumu === 12) {
                    dispatch(
                      updateExperimentationStatus(
                        genericMessage.icerik.id,
                        StatusEnum.YENI_DENEY_BASKA_DENEY_KOSULDUGU_ICIN_KABUL_EDILMEDI,
                      ),
                    );
                    // dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.icerik.deneyDurumu === 13) {
                    dispatch(updateExperimentationStatus(genericMessage.icerik.id, StatusEnum.DENEY_KAPATILDI));
                    dispatch(socketActions.hymotseStarted(false));
                  } else if (genericMessage.mesajAltTipi === 64) {
                    // 64: HYMOTS_E_UYGUNLUK_GUNCELLEMESI, icerik: { deneyCalisiyormu: true or false }

                    if (genericMessage.icerik.deneyCalisiyorMu) {
                      dispatch(socketActions.hymotseStarted(true));
                    } else {
                      dispatch(socketActions.hymotseStarted(false));
                    }
                  } else if (genericMessage.mesajAltTipi === 54) {
                    if (genericMessage.icerik.islemBasariliMi) {
                      dispatch(socketActions.hymotseStarted(false));
                    }
                  }

                  break;
              }
            }
          } else {
            // dispatch(gameActions.gameStateChanged(GameState.Idle));
          }
        } catch (error) {
          console.error('Failed to read data from surfer', error);
          // openNotification('Surfer Connection', 'Failed to read data from surfer', true);
          // dispatch(gameActions.gameStateChanged(GameState.Default));
        }
      });
    }
  }, [hymotseConnected]);

  return { hymotseSocketListenerHandler };
};
